import React from 'react'

import { Text } from '@interco/inter-ui/components/Text'
import Warning from '@/components/Warning'

import * as S from './style'

export const Exchange = () => (
  <S.Container>
    <S.Content>
      <Text variant="body-2" style={{ paddingBottom: 16, fontSize: 16 }}>
        Estes serão os dados compartilhados:
      </Text>
      <Warning text="A autorização incluirá os dados das novas contratações e operações." />
    </S.Content>
    <S.Content>
      <Text variant="body-1" bold colorWeight={500} style={{ fontSize: 18 }}>
        Operações de câmbio
      </Text>
      <Text variant="body-2" style={{ fontSize: 14 }}>
        Dados do contrato, data da contratação, data do recebimento do crédito, valor do crédito,
        data de vencimento, datas de pagamento das parcelas, período recorrente dos pagamentos,
        datas de vencimento da primeira e da última parcela, saldo devedor, prazo total, prazo
        remanescente, quantidade de prestações, prestações taxas de juros, Custo Efetivo Total,
        sistema de amortização, tarifas, Sigla identificadora da tarifa, encargos, garantias, número
        do documento da instituição consignante.
      </Text>
    </S.Content>
  </S.Container>
)
